// extracted by mini-css-extract-plugin
export var childrenContainer = "_aa-0";
export var virtualScrollArea = "_aa-1";